<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Добавить категорию
        </div>
        <DataEntryForCategory :buttonName="'Добавить'"
                              :idSelectedCategory="idSelectedCategory"
                              :parentHierarchyIds="parentHierarchyIds"
                              @apply="apply"/>
    </div>
</template>

<script>
import SVGModalClose from "../../../SVG/SVGModalClose";
import DataEntryForCategory from "./DataEntryForCategory";

export default {
    name: "AddCategory",
    components: {
        DataEntryForCategory,
        SVGModalClose
    },
    props:{
        idSelectedCategory:{
            type: Number
        },
        parentHierarchyIds:{
            type: Array
        }
    },
    methods: {
        async apply(dataCategory) {
            await this.$store.dispatch('adminPanel/categories/SAVE_CATEGORY', dataCategory);
            this.$emit('close');
        }
    }
}
</script>

<style scoped>

</style>
